export const INT_API_TEMPLATE_ARCHIVE = "int_api_template_archive";
export const INT_API_TEMPLATE_V2 = "int_api_template_v2";
export const INT_API_PROFILE = "int_api_profile";
export const INT_API_TAGS = "int_api_tags";
export const INT_API_CUSTOMER_EVENT_ATTRIBUTES =
  "int_api_customer_event_attributes";
export const INT_API_LIST_MESSAGES = "int_api_list_messages";
export const INT_API_ORG_CHANNEL_AGENTS = "int_api_org_channel_agents";
export const INT_API_CUSTOMERS_ATTRIBUTES = "int_api_customers_attributes";
